module.exports = __webpack_public_path__ + "img/icon-sprite.d5c638f8.svg";